import { Box, Paper, Typography } from '@mui/material';

import { metricCardStyles, metricCardToneMap } from './styles/metricCardStyles';

export default function MetricCard({ label, value, icon, tone = 'blue', onClick, ariaLabel }) {
  const colors = metricCardToneMap[tone] || metricCardToneMap.blue;
  const interactive = Boolean(onClick);

  return (
    <Paper
      variant="outlined"
      component={interactive ? 'button' : 'div'}
      type={interactive ? 'button' : undefined}
      onClick={onClick}
      aria-label={ariaLabel}
      sx={metricCardStyles.root(colors, interactive)}
    >
      <Box sx={metricCardStyles.iconWrap(colors)}>{icon}</Box>
      <Box sx={metricCardStyles.content}>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h5" sx={metricCardStyles.value(value, colors)} color="text.secondary">
          {value}
        </Typography>
      </Box>
    </Paper>
  );
}
